/**
 * Check Message Templates
 * Shows current templates in Firestore
 *
 * USAGE: await window.checkTemplates()
 */

import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase.js';

async function checkTemplates() {
  console.log('🔍 Checking message templates...\n');

  try {
    const templatesSnapshot = await getDocs(collection(db, 'messageTemplates'));

    console.log(`📊 Found ${templatesSnapshot.size} templates\n`);

    templatesSnapshot.docs.forEach(doc => {
      console.log(`\n=== ${doc.id} ===`);
      const data = doc.data();
      console.log('Subject:', data.subject);
      console.log('Body:', data.body);
      console.log('SMS Body:', data.smsBody);
      console.log('Variables:', data.variables);
    });

    return templatesSnapshot.docs.map(d => ({ id: d.id, ...d.data() }));

  } catch (error) {
    console.error('❌ Error:', error);
    throw error;
  }
}

export { checkTemplates };